(() => {
  const root = document.querySelector('[data-help-apps-popup]');
  if (!root) return;

  const openButton = root.querySelector('[data-help-popup-open]');
  const closeButton = root.querySelector('[data-help-popup-close]');

  const slots = {
    whatsapp: root.querySelector('[data-help-native-slot="whatsapp"]'),
    ia: root.querySelector('[data-help-native-slot="ia"]'),
    brilliant: root.querySelector('[data-help-native-slot="brilliant"]'),
    callback: root.querySelector('[data-help-native-slot="callback"]'),
    chat: root.querySelector('[data-help-native-slot="chat"]'),
  };

  function queryDeep(selector, rootNode) {
    const queue = [rootNode || document];

    while (queue.length > 0) {
      const currentRoot = queue.shift();
      if (!currentRoot || typeof currentRoot.querySelector !== 'function') continue;

      const found = currentRoot.querySelector(selector);
      if (found) return found;

      const descendants = currentRoot.querySelectorAll('*');
      descendants.forEach((node) => {
        if (node.shadowRoot) queue.push(node.shadowRoot);
      });
    }

    return null;
  }

  function createProxy(slot, key, getSource, fallbackSvg, options = {}) {
    if (!slot) return;

    const { hideWhenMissing = false, preferFallbackVisual = false } = options;

    const source = getSource();

    if (!source && hideWhenMissing) {
      slot.hidden = true;
      slot.innerHTML = '';
      return;
    }

    slot.hidden = false;

    let proxy = slot.querySelector(`[data-help-proxy="${key}"]`);
    if (!proxy) {
      proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = 'help-apps-popup__wa-proxy';
      proxy.setAttribute('data-help-proxy', key);
      proxy.setAttribute('aria-label', `Abrir ${key}`);
      slot.innerHTML = '';
      slot.appendChild(proxy);
    }

    if (!preferFallbackVisual && source && source.innerHTML && source.innerHTML.trim()) {
      proxy.innerHTML = source.innerHTML;
    } else {
      proxy.innerHTML = fallbackSvg;
    }

    proxy.onclick = (event) => {
      event.preventDefault();
      if (key === 'callback') {
        if (openMoxieCallbackFlow()) {
          closePanel();
        }
        return;
      }
      if (key === 'chat') {
        openChatFlow();
        closePanel();
        return;
      }
      const liveSource = getSource();
      if (liveSource) {
        // If source is an <a> tag, navigate directly to its href to bypass pointer-events: none
        if (liveSource.tagName === 'A' && liveSource.href) {
          const target = liveSource.target || '_blank';
          window.open(liveSource.href, target, 'noopener,noreferrer');
        } else {
          liveSource.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          if (typeof liveSource.click === 'function') {
            liveSource.click();
          }
        }
      }
      closePanel();
    };
  }

  function mountApps() {
    hideChatActivators();
    createProxy(
      slots.whatsapp,
      'whatsapp',
      () => queryDeep('#chat-bubble #whatsapp-link', document) || queryDeep('#whatsapp-link', document),
      '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.04 2.01A9.92 9.92 0 0 0 3.46 16.9L2 22l5.25-1.39a9.91 9.91 0 0 0 4.78 1.22h.01c5.47 0 9.92-4.45 9.92-9.92a9.85 9.85 0 0 0-2.9-7 9.85 9.85 0 0 0-7.02-2.9Zm5.78 14.08c-.24.69-1.43 1.27-1.98 1.35-.52.08-1.2.11-1.94-.13-.45-.15-1.03-.34-1.78-.66-3.13-1.35-5.16-4.5-5.32-4.72-.16-.22-1.27-1.7-1.27-3.25 0-1.54.81-2.3 1.1-2.62.29-.32.63-.4.84-.4h.61c.2 0 .46-.08.72.55.27.64.92 2.2 1 2.37.08.16.13.36.03.58-.1.22-.15.36-.3.55-.15.18-.31.41-.44.54-.15.15-.3.31-.13.6.17.3.75 1.24 1.62 2 .55.48 1 .79 1.33 1.02.35.22.55.19.76-.11.2-.3.87-1.02 1.1-1.37.23-.35.47-.3.78-.18.32.11 2 1 2.34 1.17.35.17.58.25.67.38.08.13.08.76-.16 1.45Z" fill="#25D366"/></svg>'
    );

    createProxy(
      slots.ia,
      'ia',
      () =>
        queryDeep('#ocular-widget-toggler', document) ||
        queryDeep('[id*="ocular-widget-toggler"]', document) ||
        queryDeep('.ocular-widget-btn', document) ||
        queryDeep('[data-ocular-widget]', document),
      '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#1D74DD"/><path d="M12 4.6L13.8 9.1L18.4 10.9L13.8 12.7L12 17.2L10.2 12.7L5.6 10.9L10.2 9.1L12 4.6Z" fill="white"/></svg>'
    );

    createProxy(
      slots.brilliant,
      'brilliant',
      () =>
        queryDeep('.bri-AssistantButton .bri-MainButton', document) ||
        queryDeep('.bri-AssistantButton', document) ||
        queryDeep('.bri-MainButton', document) ||
        queryDeep('[class*="bri-AssistantButton"]', document) ||
        queryDeep('[class*="bri-MainButton"]', document),
      '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="36" height="36" rx="10" fill="#2473D6"/><path d="M20 10V30M10 20H30M13.5 13.5L26.5 26.5M26.5 13.5L13.5 26.5" stroke="white" stroke-width="3" stroke-linecap="round"/><circle cx="13" cy="27" r="2.8" fill="white"/></svg>',
      { hideWhenMissing: true, preferFallbackVisual: true }
    );

    const callbackCustomIcon = slots.callback && slots.callback.dataset.helpSlotIcon
      ? `<img src="${slots.callback.dataset.helpSlotIcon}" width="40" height="40" alt="Te llamamos" style="width:40px;height:40px;object-fit:cover;border-radius:999px;display:block;">`
      : '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="18" fill="#00A859"/><path d="M26.44 23.64V26.34C26.44 26.84 26.24 27.31 25.89 27.66C25.54 28.01 25.07 28.21 24.57 28.21C21 28.12 17.57 26.87 14.76 24.93C12.15 23.17 10.27 20.51 11.31 17.81C11.48 17.33 11.78 16.9 12.18 16.59C12.57 16.28 13.04 16.08 13.53 16.02L15.74 15.72C16.21 15.66 16.65 15.84 16.94 16.2L18.3 18.11C18.63 18.53 18.67 19.09 18.4 19.55C18.13 20.01 17.83 20.46 17.83 20.97C17.83 21.6 18.32 22.09 18.95 22.09C19.46 22.09 19.9 21.79 20.36 21.52C20.82 21.25 21.38 21.29 21.8 21.62L23.71 22.98C24.08 23.27 24.26 23.72 24.2 24.18L23.9 26.39" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    createProxy(
      slots.callback,
      'callback',
      () => {
        // Fuera del horario de atención el widget marca el botón y la opción no se muestra en el menú.
        const boton = document.getElementById('moxie-floating-call-button');
        return boton && boton.dataset.fueraDeHorario !== 'true' ? boton : null;
      },
      callbackCustomIcon,
      { hideWhenMissing: true, preferFallbackVisual: true }
    );

    createProxy(
      slots.chat,
      'chat',
      () =>
        queryDeep('button.activator[aria-label="Chat"]', document) ||
        queryDeep('.activator-nudge button[part="activator"]', document) ||
        queryDeep('.activator-nudge button', document),
      '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="18" fill="#0066CC"/><path d="M13 13.75H27C29.9 13.75 32.25 16.1 32.25 19V26.6C32.25 29.4 30 31.7 27.2 31.8L27 31.81C25.2 31.87 23.5 32.78 22.5 34.2L20.7 36.7C20.6 36.85 20.35 36.85 20.25 36.7L18.45 34.1C17.4 32.58 15.65 31.65 13.8 31.65C10.95 31.65 8.65 29.35 8.65 26.5V19C8.65 16.1 11 13.75 13 13.75Z" stroke="white" stroke-width="2.5"/></svg>',
      { hideWhenMissing: true }
    );
  }

  var chatClickBusy = false;
  var knownNudges = [];

  // ---------------------------------------------------------------------------
  // MOXIE 2026-08: el nudge del chat se oculta SOLO con CSS !important, inyectado
  // una vez en el documento y una vez por shadow root.
  //
  // El enfoque anterior reescribía estilos inline (`applyHide`) desde:
  //   - un MutationObserver con { attributes: true } sobre el MISMO nodo que
  //     modificaba  -> loop infinito de microtasks
  //   - un loop perpetuo de requestAnimationFrame
  //   - un setInterval de 100 ms que hacía querySelectorAll('*') sobre todo el DOM
  // Medido en producción: 70 querySelectorAll('*')/s y ~70 MB/min de crecimiento
  // de heap con la página quieta. En Safari iOS eso agota el proceso de la
  // pestaña y WebKit lo mata -> "Hubo un problema repetidamente con...".
  //
  // El CSS inyectado no necesita re-aplicarse: gana a los estilos inline sin
  // !important que pone Shopify, y sobrevive a que se recree el nodo interno.
  // ---------------------------------------------------------------------------
  var HIDE_RULE =
    '.activator-nudge,.activator-nudge.activator-nudge--right{display:none!important;clip-path:inset(100%)!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}';
  var injectedStyles = [];

  function injectDocumentHide() {
    if (document.getElementById('moxie-nudge-hide')) return;
    try {
      var s = document.createElement('style');
      s.id = 'moxie-nudge-hide';
      s.textContent = HIDE_RULE;
      (document.head || document.documentElement).appendChild(s);
      injectedStyles.push(s);
    } catch (e) {}
  }

  // Inyecta un <style> dentro del shadow root para ocultar .activator-nudge via CSS propio del shadow.
  function injectShadowHide(sr) {
    if (!sr || sr._moxieInjected) return;
    sr._moxieInjected = true;
    try {
      var s = document.createElement('style');
      s.textContent = HIDE_RULE;
      sr.appendChild(s);
      injectedStyles.push(s);
    } catch (e) {}
  }

  // Desactiva/reactiva las reglas de ocultado sin tocar estilos inline.
  // Se usa solo durante openChatFlow(), que necesita el nudge en layout para
  // que el click programático sea válido.
  function setHideRulesEnabled(enabled) {
    injectedStyles.forEach(function (s) {
      try {
        s.textContent = enabled ? HIDE_RULE : '';
      } catch (e) {}
    });
  }

  function applyHide(el) {
    if (!el) return;
    el.style.removeProperty('display');
    el.style.removeProperty('visibility');
    el.style.removeProperty('opacity');
    el.style.removeProperty('pointer-events');
  }

  function findChatNudge() {
    // Shopify puede anidar el nudge en más de un nivel de shadow DOM (p.ej.
    // shopify-chat > shadow > shopify-agent-runtime > shadow > .activator-nudge),
    // por eso se usa queryDeep (BFS recursivo) en vez de mirar un solo nivel.
    var el = queryDeep('.activator-nudge', document);
    if (!el) return null;
    return { nudge: el, activator: el.querySelector('button') };
  }

  // Barrido acotado: inyecta el <style> en los shadow roots que contienen el
  // nudge. Idempotente (flag _moxieInjected), así que repetirlo no cuesta nada
  // más que el recorrido; por eso está estrangulado y con condición de parada.
  var lastScan = 0;
  var scanScheduled = false;
  var nudgeFound = false;
  var SCAN_THROTTLE_MS = 500;

  function scanNow() {
    if (chatClickBusy) return;
    lastScan = Date.now();
    injectDocumentHide();

    if (document.querySelector('.activator-nudge')) nudgeFound = true;

    // BFS a través de todos los niveles de shadow DOM (no solo el primero):
    // Shopify puede anidar shopify-agent-runtime dentro del shadow de
    // shopify-chat, así que un solo nivel no basta para encontrar el nudge.
    var queue = [document];
    while (queue.length > 0) {
      var currentRoot = queue.shift();
      var descendants = currentRoot.querySelectorAll('*');
      for (var i = 0; i < descendants.length; i++) {
        var sr = descendants[i].shadowRoot;
        if (!sr) continue;
        queue.push(sr);
        if (sr._moxieInjected) continue;
        if (!sr.querySelector('.activator-nudge')) continue;
        injectShadowHide(sr);
        nudgeFound = true;
      }
    }
  }

  function scheduleScan() {
    if (scanScheduled || chatClickBusy) return;
    scanScheduled = true;
    var wait = Math.max(0, SCAN_THROTTLE_MS - (Date.now() - lastScan));
    setTimeout(function () {
      scanScheduled = false;
      scanNow();
    }, wait);
  }

  // Compatibilidad: el resto del archivo llamaba a hideChatActivators().
  function hideChatActivators() {
    scheduleScan();
  }

  function openChatFlow() {
    if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') { window.ShopifyChat.open(); return; }
    if (window.Shopify && window.Shopify.chat && typeof window.Shopify.chat.open === 'function') { window.Shopify.chat.open(); return; }
    if (window.Intercom) { window.Intercom('show'); return; }
    if (window.GorgiasChat) { window.GorgiasChat.open(); return; }
    if (window.zE) { window.zE('webWidget', 'open'); return; }

    var initial = findChatNudge();
    if (!initial) return;

    // Si el chat ya está abierto no volver a hacer click (lo cerraría en vez de abrirlo)
    if (initial.activator && initial.activator.getAttribute('aria-expanded') === 'true') return;

    chatClickBusy = true;
    window._chatClickBusy = true;
    // El nudge tiene que estar en layout para que el click programático valga:
    // se desactivan las reglas CSS de ocultado durante el flujo.
    setHideRulesEnabled(false);

    // Mostrar el nudge en layout pero invisible (opacity:0) para que el click sea válido.
    // position:static garantiza offsetParent != null.
    try {
      initial.nudge.style.setProperty('display', 'flex', 'important');
      initial.nudge.style.setProperty('visibility', 'visible', 'important');
      initial.nudge.style.setProperty('opacity', '0', 'important');
      initial.nudge.style.setProperty('pointer-events', 'none', 'important');
      initial.nudge.style.setProperty('position', 'static', 'important');
      initial.nudge.style.setProperty('top', 'auto', 'important');
      initial.nudge.style.setProperty('left', 'auto', 'important');
    } catch (e) {}

    setTimeout(function () {
      // Re-buscar el elemento: Shopify puede haber recreado el nodo durante los 60ms
      var current = findChatNudge() || initial;
      var nudge = current.nudge || initial.nudge;
      var activator = current.activator || initial.activator;

      // Asegurar que el nodo actual está en layout (puede ser diferente al inicial)
      try {
        nudge.style.setProperty('display', 'flex', 'important');
        nudge.style.setProperty('visibility', 'visible', 'important');
        nudge.style.setProperty('opacity', '0', 'important');
        nudge.style.setProperty('position', 'static', 'important');
        nudge.style.setProperty('top', 'auto', 'important');
        nudge.style.setProperty('left', 'auto', 'important');
      } catch (e) {}

      try {
        if (activator) {
          activator.style.setProperty('display', 'flex', 'important');
          activator.style.setProperty('visibility', 'visible', 'important');
          activator.style.setProperty('opacity', '0', 'important');
          activator.dispatchEvent(new MouseEvent('click', {
            bubbles: true, cancelable: true, view: window, composed: true
          }));
        }
      } catch (e) {}

      // Liberar siempre — aunque algo falle arriba
      chatClickBusy = false;
      window._chatClickBusy = false;
      setHideRulesEnabled(true);

      try {
        applyHide(nudge);
        nudge.style.removeProperty('position');
        nudge.style.removeProperty('top');
        nudge.style.removeProperty('left');
      } catch (e) {}

      try {
        if (activator) {
          activator.style.removeProperty('display');
          activator.style.removeProperty('visibility');
          activator.style.removeProperty('opacity');
        }
      } catch (e) {}

      // Si el elemento cambió, limpiar también el viejo
      if (nudge !== initial.nudge) {
        try { applyHide(initial.nudge); } catch (e) {}
      }

      requestAnimationFrame(hideChatActivators);
    }, 60);
  }

  // Descubrimiento del nudge: solo cuando se INSERTAN nodos, estrangulado a
  // 500 ms, y con parada definitiva a los 60 s. Antes: RAF perpetuo + observer
  // sobre todo el documento + setInterval de 100 ms, todo sin cleanup.
  var chatHideObserver = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes && records[i].addedNodes.length) {
        scheduleScan();
        return;
      }
    }
  });
  chatHideObserver.observe(document.documentElement, { childList: true, subtree: true });
  scanNow();

  // Shopify Inbox se monta en los primeros segundos. Pasada la ventana de
  // arranque el CSS inyectado ya es suficiente: se corta el observer para que
  // el estado estacionario de la página sea 0 barridos/s.
  var stopWatchTimer = setTimeout(function () {
    try { chatHideObserver.disconnect(); } catch (e) {}
  }, 60000);

  window.addEventListener('pagehide', function () {
    try { chatHideObserver.disconnect(); } catch (e) {}
    clearTimeout(stopWatchTimer);
  });

  function openMoxieCallbackFlow() {
    if (window.MoxieFloatingCallWidget && typeof window.MoxieFloatingCallWidget.openForm === 'function') {
      window.MoxieFloatingCallWidget.openForm(openPanel);
      return true;
    }
    return false;
  }

  function openPanel() {
    if (root.classList.contains('is-suspended')) return;
    root.classList.add('is-open');
    if (openButton) openButton.setAttribute('aria-expanded', 'true');
    mountApps();
  }

  function closePanel() {
    root.classList.remove('is-open');
    if (openButton) openButton.setAttribute('aria-expanded', 'false');
  }

  function isCartOverlayOpen() {
    const cartNotification = document.getElementById('cart-notification');
    const cartDrawer = document.querySelector('cart-drawer');
    const ctoDrawer = document.querySelector('.drawer--cto');

    // MOXIE 2026-08: solo clases explícitas — getComputedStyle causaba falsos
    // positivos porque #cart-notification siempre está visible en el header
    // (muestra el conteo). El popup se cerraba solo por eso.
    const notificationVisible = !!cartNotification && (
      cartNotification.classList.contains('active') ||
      cartNotification.classList.contains('minicart-active')
    );

    const drawerVisible = !!cartDrawer && cartDrawer.classList.contains('active');
    const ctoDrawerVisible = !!ctoDrawer && ctoDrawer.classList.contains('active');

    return notificationVisible || drawerVisible || ctoDrawerVisible;
  }

  function syncBlockedState() {
    const shouldSuspend = isCartOverlayOpen();
    root.classList.toggle('is-suspended', shouldSuspend);
    if (shouldSuspend) closePanel();
  }

  if (openButton) {
    openButton.addEventListener('click', () => {
      const isOpen = root.classList.contains('is-open');
      if (isOpen) {
        closePanel();
        return;
      }
      openPanel();
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', closePanel);
  }

  // MOXIE 2026-08: mousedown en vez de click — los clicks programáticos
  // (.click() de otros scripts, como insuranceInput.click() en product-cto-configurable.js)
  // disparan 'click' pero NO 'mousedown', así que no cierran el popup.
  document.addEventListener('mousedown', (event) => {
    if (!root.classList.contains('is-open')) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!root.contains(target)) closePanel();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanel();
  });

  // Lightweight refresh in case third-party widgets load late.
  let retries = 0;
  const retryTimer = setInterval(() => {
    mountApps();
    syncBlockedState();
    retries += 1;
    if (retries >= 30) {
      clearInterval(retryTimer);
    }
  }, 1000);

  // Keep help launcher hidden while cart preview/drawer overlays are open.
  // MOXIE 2026-08: 250 ms -> 600 ms y con handle realmente limpiable. El
  // carrito además se sincroniza por eventos, así que el timer es solo red de
  // seguridad y no necesita esa frecuencia.
  const blockStateTimer = setInterval(syncBlockedState, 600);

  // MOXIE 2026-08: 'click' eliminado de la lista — disparaba syncBlockedState
  // en cada clic, lo que cerraba el popup inmediatamente si isCartOverlayOpen
  // daba falso positivo. Los eventos de carrito son suficientes + el timer 600ms.
  ['cart:refresh', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      requestAnimationFrame(syncBlockedState);
    });
  });

  window.addEventListener('pagehide', function () {
    clearInterval(blockStateTimer);
    clearInterval(retryTimer);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) return;
    syncBlockedState();
  });

  mountApps();
  syncBlockedState();
})();